import React, { useRef, useEffect } from 'react';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';

// Import CSS directly
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';

const VideoPlayer = ({ videoUrl, title }) => {
  const playerRef = useRef(null);
  const containerRef = useRef(null);
  
  useEffect(() => {
    // Disable right-click on the container
    if (containerRef.current) {
      containerRef.current.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        return false;
      });
      
      // Find the video element within the container and disable right-click on it specifically
      setTimeout(() => {
        const videoElement = containerRef.current.querySelector('video');
        if (videoElement) {
          videoElement.addEventListener('contextmenu', (e) => {
            e.preventDefault();
            return false;
          });
          
          // Disable controls that might allow download
          videoElement.controlsList = "nodownload";
        }
      }, 1000); // Give the player time to render the video element
    }
  }, [videoUrl]);
  
  return (
    <div className="flex flex-col items-center justify-center py-10 px-4">
      <div className="w-full max-w-4xl mx-auto">
        <div 
          ref={containerRef} 
          className="rounded-xl overflow-hidden shadow-lg bg-white p-4"
          onContextMenu={(e) => {
            e.preventDefault();
            return false;
          }}
        >
          {/* Video player with right-click and download disabled */}
          <MediaPlayer 
            ref={playerRef}
            title={title || "Video Contenuto"} 
            src={videoUrl}
            crossOrigin
            playsinline
            poster="https://via.placeholder.com/800x450?text=Caricamento+Video"
          >
            <MediaProvider />
            <DefaultVideoLayout 
              icons={defaultLayoutIcons} 
              noDownload
            />
          </MediaPlayer>
        </div>
        <p className="text-gray-700 text-center mt-6">
          Questo contenuto è ad accesso esclusivo e protetto da copyright
        </p>
      </div>
    </div>
  );
};

export default VideoPlayer;